import { useBaseAppDevStore } from "../stores/index.js";
import { DataService } from "../services/data.service.js";
import { useAccountStore } from "../stores/account.js";
import { errorMsg, msgData } from "./utils.js";

export const evaluateDecisionTable = async (data) => {
  try {
    const { flowId, payload } = data;
    const evaluatedOutput = await fetchDecisionTable(flowId, payload);

    return msgData(data, {
      evaluatedOutput
    });
  } catch (e) {
    return errorMsg(data, e);
  }
};

export const fetchDecisionTable = async (flowId, payload = {}) => {
  const accountId = useAccountStore.getState()._id;
  const currentAppId = useBaseAppDevStore.getState().currentAppId;

  let [getEvaluatedOutput] = DataService.post(
    `/application/2/${accountId}/${currentAppId}/sdk/decisiontable/${flowId}/execute`,
    {
      data: payload
    }
  );

  let evaluatedOutput = await getEvaluatedOutput();
  return evaluatedOutput;
};
